export default "<!-- exito -->\r\n<div class=\"opacity-exito\">\r\n  <div class=\"loading\"></div>\r\n</div>\r\n<!-- cierra exito -->\r\n"